<template>
  <vue-scroll class="login-page align-vertical">
    <div class="form-wrapper align-vertical-middle">
      <div class="form-box card-base card-shadow--medium white-text">
        <img
          class="image-logo"
          :src="logoURL"
          alt="logo"
          style="margin-bottom: 0"
        />

        <p
          v-if="mfaMode !== 'app'"
          class="text-left mb-20"
          style="font-size: 13.5px"
        >
          We just sent you a message via
          {{ mfaMode === "sms" ? "SMS" : "email" }} with your authentication
          code. Enter the code in the form below to verify your identity.
        </p>
        <div v-else class="white-text" style="font-size: 14px">
          <p>
            Use the authentication code from your authenticator app. Enter the
            code in the form below to verify your identity.
          </p>
        </div>

        <form class="mt-0" @submit.prevent="submit">
          <el-input
            v-model="otp"
            ref="code"
            placeholder="XXXXXX"
            maxlength="6"
            v-mask="'######'"
            v-loading="processing"
          >
            <template slot="prefix">Code</template>
          </el-input>
        </form>

        <div v-if="mfaMode !== 'app'">
          <hr />
          <p style="font-size: 14px">
            Didn't get a code?
            <el-button
              native-type="button"
              type="text"
              size="small"
              style="padding: 0"
              v-loading="resendProcessing"
              :disabled="resendProcessing"
              @click="() => resendOTP()"
            >
              Resend code
            </el-button>
          </p>
        </div>

        <p v-if="mfaMode !== 'email'" style="font-size: 14px">
          {{
            mfaMode === "app"
              ? "Trouble with the App"
              : "Trouble receiving SMS"
          }}?
          <el-button
            native-type="button"
            type="text"
            size="small"
            style="padding: 0"
            v-loading="emailProcessing"
            :disabled="emailProcessing"
            @click="() => resendOTP(true)"
          >
            Email code
          </el-button>
        </p>
      </div>
    </div>
  </vue-scroll>
</template>

<script>
import { apiV2Host } from "@/feathers/feathers-client";

export default {
  name: "ValidateMFA",

  data() {
    return {
      otp: "",
      processing: false,
      resendProcessing: false,
      emailProcessing: false,
    };
  },

  watch: {
    otp() {
      if (this.otp.length === 6) {
        this.submit();
      }
    },
  },

  computed: {
    logoURL() {
      return this.$store.state.branding.logoOnlyURL;
    },

    mfaMode() {
      return this.$route.query.mode;
    },

    formValid() {
      return this.otp && this.otp.length === 6;
    },
  },

  methods: {
    notifyErrorOnApiCall(json = {}) {
      const { name, code, message } = json;
      if (code && ["4", "5"].includes(`${code}`[0])) {
        this.$notify({
          title: name,
          message: message,
          type: "error",
        });
        this.otp = "";
      }
    },

    async submit() {
      try {
        this.processing = true;

        const { query } = this.$route;

        const body = {
          token: query.token,
          otp: this.otp,
        };

        const res = await fetch(`${apiV2Host}/mfa/validate`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const json = await res.json();

        const { accessToken } = json;

        if (accessToken) {
          await this.$store.dispatch("auth/authenticate", {
            strategy: "jwt",
            accessToken: accessToken,
          });
          this.$store.commit("setLogin");
          this.$router.push("/omnia/contacts");
        }

        this.notifyErrorOnApiCall(json);
        this.processing = false;
      } catch (err) {
        this.processing = false;
        this.$notify({
          title: err.name,
          message: err.message,
          type: "error",
        });
      }
    },

    async resendOTP(emailCode = false) {
      try {
        if (emailCode) {
          this.emailProcessing = true;
        } else {
          this.resendProcessing = true;
        }

        const { query } = this.$route;

        const body = {
          token: query.token,
          mode: emailCode ? "email" : this.mfaMode,
        };

        if (body.mode === "sms") {
          body.phoneNumber = query.phoneNumber;
        }

        const res = await fetch(`${apiV2Host}/mfa/resend-otp`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const json = await res.json();
        this.resendProcessing = false;
        this.emailProcessing = false;

        const { mfaVerifyToken, mode } = json;

        if (mfaVerifyToken) {
          const deviceType = mode === "sms" ? "phone number" : "email";

          this.$notify({
            title: "Check your inbox",
            message: `A 6-digit code has been resent to your ${deviceType}.`,
            type: "success",
          });

          this.$router.push({
            path: "validate-mfa",
            query: { ...query, token: mfaVerifyToken },
          });
        }

        this.notifyErrorOnApiCall(json);
      } catch (err) {
        this.resendProcessing = false;
        this.emailProcessing = false;
        this.$notify({
          title: err.name,
          message: err.message,
          type: "error",
        });
      }
    },
  },

  mounted() {
    this.$refs.code.focus();
  },
};
</script>

<style lang="scss" scoped>
.card-base form {
  margin-top: 0;
  padding-top: 0;
}
</style>
